
// ------------CORE--------------
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

// ----------ROUTING-------------
import { AppRoutingModule } from "./app-routing.module";

// ---------COMPONENTS-----------
import { AppComponent } from './app.component';

// ----------SERVICES------------
import { HandlerService } from './core/handlers/handlers.service';
import { MethodsService } from './core/http/method.service';
import { HomeService } from './core/http/web/home.service';
import { HttpModule } from '@angular/http';


// -----------MODULES------------
import { TemplateModule } from './template/template.module';
import { HttpClientModule } from '@angular/common/http';
import { WidgetService } from './core/http/web/widget.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { RouterExtService } from './core/services/utilities/router-ex.service';
// ------------------------------
import { NgxMaskModule, IConfig } from 'ngx-mask'
export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};
@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    HttpModule,
    BrowserModule,
    AppRoutingModule,
    TemplateModule,
    HttpClientModule,
    BrowserAnimationsModule,

    NgxMaskModule.forRoot(options)
  ],
  providers: [
    // -----SERVICES----------
    HandlerService,
    MethodsService,
    HomeService,
    WidgetService,
    CookieService,
    RouterExtService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
